import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

// assets
import "../css/app.css";

export default class Index extends React.Component {
  render() {
    return (
      <main>
        <div className="in-grid">
        <div className="fullwidth"></div>
                <div className="cb-hero-header flex jcc aic" >
                    <div  >
                        <h1>Hi, </h1>
                        <h1>I'm </h1>
                        <h1>Corey</h1>
                    </div>
                </div>

            <p className="cb-caption tar ">shot on Canon A1 Film Camera</p>
        </div>

        <div className="flex jcc pad-50 meet-corey">
            <div className="one-third" >
                <img src="https://s3.amazonaws.com/cmb-portfolio-16/corey_brown_01.JPG" width="300" height="auto" />
            </div>
            <div className="one-fourth">
                <h2>I'm Corey Brown</h2>
                <p id="thats-me-left" className="cb-caption"> that's me.</p>
                <p id="thats-me-up" className="cb-caption">^ that's me.</p>
                <p>
                   Hi, I'm Corey. I've always been into building things with/for others. It started with music when I was in grade school and progressed into video-editing in middle-school, then by high-school I was really into Apple's iWeb...anyone remember that? The point is, I've always loved pushing myself to learn new things.
                </p>
            </div>
        </div>

        <div className="in-grid video-2-up">
            <div className="full-width flex jcsa">
                <div className="cb-video-img-1"></div>
                <div id="video" className="cb-video-img-2"></div>
            </div>
        </div>

        <div className="in-grid video-skills">
            <div className="two-thirds">
            <h2>&lt;video&gt;</h2>
                <p>Video production and editing have been part of my life for around 17 years. Wow, crazy when you put a number to it. Since 2009, I've held jobs as a video producer &amp; editor for several organizations including non-profits, agencies, and even my own business for a while.   <Link to="/video"><strong>View video work.</strong></Link>
                </p>
            </div>
        </div>

        <div className="fullwidth pad-50">
            <div className="cb-video-img3"></div>
        </div>

        <div id="web" className="in-grid flex fdr jcsb pad-80 dev-skills">
            <div className="one-half" >
                <h2>.front-end-dev </h2>
                <p>Web development is something that I cannot get enough of. About 6 years ago I started a small WordPress business building sites for friends and really fell in love with the web. Today, I've continued that passion and I'd consider it my main thing now. I enjoy building sites that are as fast as they are pretty and functional. At home, in my free time, you can usually find me learning a new language or library. You could say I'm addicted.</p>
            </div>
            <div className="one-third flex fdc jcc"  >
                <ul className="cb-skills">
                    <li>html</li>
                    <li>Css</li>
                    <li>Javascript</li>
                    <li>Jquery</li>
                    <li>PHP</li>
                    <li>Wordpress</li>
                </ul>
            </div>
        </div>

        <div className="fullwidth flex">
                <div className="one-half cb-photos-img1"></div>
                <div className="one-half cb-photos-img2"></div>
        </div>

     <div id="fam" className="in-grid pad-80 family flex jcc">
         <div className="one-third bastille flex fdc aic asc">
             <img src="https://s3.amazonaws.com/cmb-portfolio-16/bastille-02.jpg" alt="Meet our dog." width="100%" />
             <h2 className="tac">Our dog, Bastille</h2>
             <p className="cb-caption tac">Boston Terrier</p>
         </div>
         <div className="one-half relative">
             <img src="https://s3.amazonaws.com/cmb-portfolio-16/christina.jpg" alt="Meet my wife." width="100%" />
                <h2 className="tac">My wife, Christina</h2>
                <p className="cb-caption tac">Married since January 2013.</p>
         </div>
     </div>
   </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js